import httpClient from './httpClient';
import { ENDPOINT_API } from '../../enums/endpoint';

const getMe = () => httpClient.get(`${ENDPOINT_API.ME}`);
const putMe = (params) => httpClient.put(`${ENDPOINT_API.ME}`, params);

export {
	getMe,
	putMe,
};
